import Repository from '../axios'

const resource = "/customer/notifications";

export default {
  getUnreadNotifications() {
    return Repository.get(`${resource}/unread`)
  },
  getAllNotifications() {
    return Repository.get(`${resource}`)
  },
  notificationMarkAsRead(id) {
    return Repository.put(`${resource}/mark-as-read`, { id: id })
  },
  notificationMarkAsUnRead(id) {
    return Repository.put(`${resource}/mark-as-unread`, { id: id })
  },
  notificationMarkAllAsRead() {
    return Repository.put(`${resource}/mark-all-as-read`)
  }
};
